// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wZVo","col":"styles_col__2-VKC","actions":"styles_actions__1ZtJn","conflict":"styles_conflict__3PGLT"};